var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F5F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5B4FC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818CF8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "24.537%",
    x2: "50%",
    y2: "100%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4338CA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "a",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 40
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M21.552 0l21.486 43.134-21.486-6.74-21.486 6.74z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-51 40.768 12.852)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#e)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    mask: "url(#g)",
    d: "M21.329-8.887h27.236v51.639H21.329z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.837 47.371c5.258 3.84 11.206 6.728 17.441 8.526.342.1.43-.207.093-.314-3.07-.956-5.985-2.416-8.75-4.047-2.77-1.634-5.393-3.434-8.053-5.163-1.072-.707-1.842.175-.731.998M54.693 54.349c9.628 10.935 19.319 21.864 28.966 32.796.529.599.767.387.244-.217-9.496-10.97-18.431-22.733-28.284-33.397-2-2.166-2.962-1.495-.926.818",
    fillOpacity: 0.4,
    fill: "#475569"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading-icon.859a2773955d731afc9914e62c42fa0e.svg";
export { ForwardRef as ReactComponent };